import CanonicalTag from "./CanonicalTag";

/** Sets `<link rel="canonical">` from the current route pathname. */
const RouteCanonical = () => <CanonicalTag />;

export default RouteCanonical;
